"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeeklySchedulePanel = void 0;
const react_1 = __importDefault(require("react"));
require("./types");
const WeeklyScheduleControl_1 = require("../WeeklyScheduleControl");
const WeeklySchedulePanel = ({ dailyScheduleModel, weeklyScheduleModel, monthlyScheduleModel, yearlyScheduleModel, onDone, onCancel, texts, dailyRetentionFieldsSettings, weeklyRetentionFieldsSettings, }) => {
    return (react_1.default.createElement(WeeklyScheduleControl_1.WeeklyScheduleControl, { dailyScheduleModel: dailyScheduleModel, yearlyScheduleModel: yearlyScheduleModel, monthlyScheduleModel: monthlyScheduleModel, weeklyScheduleModel: weeklyScheduleModel, onDone: onDone, onCancel: onCancel, texts: texts, dailyRetentionFieldsSettings: dailyRetentionFieldsSettings, weeklyRetentionFieldsSettings: weeklyRetentionFieldsSettings }));
};
exports.WeeklySchedulePanel = WeeklySchedulePanel;
//# sourceMappingURL=WeeklySchedulePanel.js.map